import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { feedKindFromPath, getFeedConfig } from '@/lib/feed-config';

const FeedContext = createContext({ kind: 'main', config: null });

export function FeedProvider({ children }) {
  const location = useLocation();
  const kind = feedKindFromPath(location.pathname);
  const config = useMemo(() => getFeedConfig(kind), [kind]);

  useEffect(() => {
    document.documentElement.style.setProperty('--feed-accent', config.accent);
  }, [config]);

  return <FeedContext.Provider value={{ kind, config }}>{children}</FeedContext.Provider>;
}

export function useFeed() {
  return useContext(FeedContext);
}
